import React, { useEffect, useState } from "react";
import "./index.css";
import { usePermissions } from "src/components/Contexts/PermissionsContext";
import { useCountrySelection } from "src/components/Contexts/CountrySelectionContext";
import ImpersonateButton from "./ImpersonateButton";
import NestButton from "./NestButton";
import { getUser, User } from "src/api/interfaces/user";
import { isPageAllowed } from "src/api/interfaces/pageUtils";

interface NestNavBarProps {
  isNest?: boolean;
}

export default function NestNavBar({ isNest }: NestNavBarProps) {
  const { permissions } = usePermissions();
  const { selectedCountry } = useCountrySelection();
  const [isNestAvailable, setIsNestAvailable] = useState(false);
  const user = getUser();
  useEffect(() => {
    if (!selectedCountry) {
      return;
    }
    setIsNestAvailable(isPageAllowed("NEST"));
  }, [selectedCountry, permissions, user]);

  if (!isNestAvailable) {
    return null;
  }

  return (
    <div className="nest-nav-bar">
      {!(isNest && !isPageAllowed("AIC")) && <NestButton isNest={isNest} />}
      {isNest && user === User.STANDALONE && (
        <>
          <ImpersonateButton />
        </>
      )}
    </div>
  );
}
